export default "__VITE_ASSET__Do0AIjN3__"